//
import React from 'react'
import AppContext from "../../context/AppContext";
//
import Index from "./manufacturer/Index";
import View from "./manufacturer/View";
import Create from "./manufacturer/Create";
import Update from "./manufacturer/Update";
import NoPage from "../NoPage";

class Manufacturer extends React.Component {

    static contextType = AppContext;

    /**
     * @return {AppBase}
     */
    app = () => {
        return this.context;
    }

    render = () => {
        let $pages = []
        let $app = this.app()

        $pages.push($app.content.showPage(<Index/>, 'Manufacturer', 'Index'))
        $pages.push($app.content.showPage(<Create/>, 'Manufacturer', 'Create'))
        $pages.push($app.content.showPage(<Update/>, 'Manufacturer', 'Update'))
        $pages.push($app.content.showPage(<View/>, 'Manufacturer', 'View'))

        return ($pages.join('') === '' ? <NoPage/> : $pages);
    }
}

export default Manufacturer;